// Leaving an export here for backwards compatibility
import {default as StyledOcticon} from '../Octicon/Octicon'

export default StyledOcticon
export type {OcticonProps as StyledOcticonProps} from '../Octicon/Octicon'
